require('./shared/layout');

import $ from 'jquery';
import Axios from 'axios';
import { parseQueryParams } from './shared/utils';

const axios = Axios.create({ withCredentials: true });
$(document).ready(function () {
  var searchParams = parseQueryParams(window.location.search || '');

  var formError;
  var loginSuccess;
  var processing;

  var activateExplicitSignInForm = function () {
    // $('#form_auth').removeClass('inactive');
    if (this.dataset.placeholder) {
      this.setAttribute('placeholder', this.dataset.placeholder);
    }
  };

  $('#input_uid').focus(activateExplicitSignInForm);

  var isSignupPage = window.location.href.indexOf('/signup') > -1;

  var sleep = function (ms) {
    return new Promise((res) => {
      setTimeout(res, ms);
    });
  };

  var setFormError = function (error) {
    formError = error;
    var el = $('#form_error');
    if (error == null) {
      el.text('');
      el.hide();
    } else {
      el.text(error.message || error);
      el.show();
    }
  };

  var setFormSuccess = function () {
    loginSuccess = true;
  };

  var setProcessing = function (state) {
    processing = state;
    var btn = $('#form_auth .cta_wrap .cta_btn');
    if (processing === true) {
      btn.addClass('processing');
    } else {
      btn.removeClass('processing');
    }

    btn.attr('disabled', processing);
    var inputs = $('#form_auth input');
    inputs.attr('disabled', processing);
    $('[data-password-toggle]').attr('disabled', processing);
  };

  var initPasswordToggles = function () {
    $('[data-password-toggle]').on('click', function () {
      var btn = $(this);
      var input = btn.closest('.auth-password-field').find('input').first();
      var isVisible = input.attr('type') === 'text';

      input.attr('type', isVisible ? 'password' : 'text');
      btn.toggleClass('is-visible', !isVisible);
      btn.attr('aria-pressed', String(!isVisible));
      btn.attr('aria-label', isVisible ? 'Show password' : 'Hide password');
    });
  };

  var activateForm = function () {
    $('.form_wrapper').addClass('activated');
  };

  var showEmailSignin = function () {
    $('body').addClass('auth-email-active');
    setFormError(null);
    setTimeout(function () {
      $('#input_uid').focus();
    }, 0);
  };

  var clearDirectAuthSearchParams = function () {
    var directAuthKeys = ['auth_form', 'email'];

    if (searchParams.auth === 'email') {
      directAuthKeys.push('auth');
    }

    directAuthKeys.forEach(function (key) {
      delete searchParams[key];
    });

    if (window.URL && window.history && window.history.replaceState) {
      var currentUrl = new URL(window.location.href);

      directAuthKeys.forEach(function (key) {
        currentUrl.searchParams.delete(key);
      });

      window.history.replaceState({}, document.title, currentUrl.toString());
    }

    $('[data-auth-link]').each(function (i, a) {
      if (!window.URL) return;

      var hrefUrl = new URL(a.href);
      directAuthKeys.forEach(function (key) {
        hrefUrl.searchParams.delete(key);
      });

      a.href = hrefUrl.toString();
    });
  };

  var showSigninOptions = function () {
    $('body').removeClass('auth-email-active');
    setFormError(null);
    clearDirectAuthSearchParams();
  };

  var shouldShowEmailForm = function () {
    return searchParams.email ||
      searchParams.auth === 'email' ||
      searchParams.auth_form === 'email';
  };

  var initAuthShowcaseCarousel = function () {
    var carousel = $('.auth-showcase-carousel');
    if (!carousel.length) return;

    var slides = carousel.find('.auth-showcase-slide');
    var controls = carousel.find('.auth-carousel-indicators button');
    if (!slides.length) return;

    var activeIndex = 0;
    var slideIntervalMs = 4000;
    var slideTimer;

    carousel.addClass('auth-carousel-js');
    slides.eq(activeIndex).addClass('is-active');
    controls.eq(activeIndex).addClass('is-active').attr('aria-selected', 'true');

    var setSlide = function (nextIndex) {
      nextIndex = Number(nextIndex);
      if (Number.isNaN(nextIndex) || nextIndex < 0 || nextIndex >= slides.length || nextIndex === activeIndex) return;

      var currentSlide = slides.eq(activeIndex);
      var nextSlide = slides.eq(nextIndex);

      currentSlide.removeClass('is-active').addClass('is-leaving');
      nextSlide.removeClass('is-leaving');

      if (nextSlide[0]) {
        nextSlide[0].offsetHeight;
      }

      nextSlide.addClass('is-active');

      if (controls.length) {
        controls.removeClass('is-active').attr('aria-selected', 'false');
        controls.eq(nextIndex).addClass('is-active').attr('aria-selected', 'true');
      }

      activeIndex = nextIndex;

      setTimeout(function () {
        currentSlide.removeClass('is-leaving');
      }, 520);
    };

    var showNextSlide = function () {
      setSlide((activeIndex + 1) % slides.length);
    };

    var restartAutoSlide = function () {
      if (slideTimer) {
        clearInterval(slideTimer);
      }

      if (slides.length > 1) {
        slideTimer = setInterval(showNextSlide, slideIntervalMs);
      }
    };

    if (controls.length) {
      controls.on('click', function () {
        setSlide(this.dataset.slide);
        restartAutoSlide();
      });
    }

    restartAutoSlide();
  };

  var onSignedin = function () {
    $('.title_main').text('Signed in');
    $('.titles_wrap .desc').text('Checking redirections ..');

    var redirecUri = searchParams.redirect;
    if (redirecUri) {
      redirecUri = decodeURI(searchParams.redirect);
    } else {
      redirecUri = process.env.LOGIN_REDIRECT_URL + window.location.search;
    }

    window.location.href = redirecUri;
    $('#form_auth').hide();
    $('.social-connect-wrap').hide();
  };

  var onSiginFailed = function (err) {
    setFormError(err);
    $('#input_password').val('');
  };

  var getRequestError = function (e) {
    if (e && e.response && e.response.data) {
      return e.response.data;
    }

    if (e && e.message) {
      return {
        message: e.message === 'Network Error'
          ? 'Unable to reach the authentication server. Please check your connection and try again.'
          : e.message,
      };
    }

    return {
      message: 'Unable to sign in right now. Please try again.',
    };
  };

  function onFormSubmit(ev) {
    ev.preventDefault();
    if (processing) return;

    var name = $('#input_name');
    var email = $('#input_uid');
    var pass = $('#input_password');
    var promoConsent = $('#promosConsent');

    var nameValue = name.val();
    var emailValue = email.val();
    var passValue = pass.val();

    if (!emailValue || !passValue) {
      return setFormError({
        message: 'Please type in your email and password',
      });
    }

    if (isSignupPage && passValue.length < 8) {
      return setFormError({
        message: 'Password must be at least 8 characters long',
      });
    }

    var payload = {
      email: emailValue,
      // password: passValue,
      passphrase: passValue,
      promosConsent: promoConsent.prop('checked'),
    };

    if (isSignupPage) {
      if (!nameValue) {
        return setFormError({
          message: 'Please type in your name',
        });
      }

      payload.name = nameValue;
    } else {
      payload.scope = ['root'];
    }

    setFormError(null);
    setProcessing(true);

    setTimeout(() => {
      signin(payload).then(
        function (res) {
          console.log('res', res && res.data);
          setFormSuccess(true);
          onSignedin();

          setProcessing(false);
        },
        function (e) {
          onSiginFailed(getRequestError(e));

          setProcessing(false);
        },
      );
    }, 1000);
  }

  function checkSession() {
    // return activateForm();
    var apiurl = process.env.AUTH_API_BASE + '/auth/access_token';
    axios.get(apiurl).then(onSignedin, function (e) {
      console.log('not logged in', e.response);
      activateForm();

      if (searchParams.email) {
        activateExplicitSignInForm();
      }
    });
  }

  function checkAutoFill() {
    if (searchParams.email) {
      $('#input_uid').val(searchParams.email);
    }
  }

  function prependSearchParams() {
    $('[data-auth-link]').each((i, a) => {
      var hrefurl = $(a).prop('href');
      var appendParam = function (prop, value) {
        if (hrefurl.indexOf(prop + '=') > -1) return;
        hrefurl += hrefurl.indexOf('?') > -1 ? '&' : '?';
        hrefurl += encodeURIComponent(prop) + '=' + encodeURIComponent(value);
      };

      if (a.dataset.authDirectForm) {
        appendParam('auth_form', a.dataset.authDirectForm);
      }

      var searchParamKeys = Object.keys(searchParams);
      if (searchParamKeys.length) {
        searchParamKeys.forEach((prop) => {
          appendParam(prop, searchParams[prop]);
        });
      }

      a.href = hrefurl;
    });
  }

  function signin(payload) {
    return new Promise(function (res, rej) {
      payload = Object.assign(payload);

      var apiPathname = '/auth/signin';
      if (isSignupPage) {
        apiPathname = '/auth/signup';
      }

      // return console.log('signinURL', signinURL);
      var apiUri = process.env.AUTH_API_BASE + apiPathname;
      axios.post(apiUri, payload).then(res, rej);
    });
  }

  // @signin
  var onConnectAppClick = function () {
    var appName = this.dataset.app;
    var oauthURI =
      process.env.AUTH_API_BASE + '/apps/connect?appName=' + appName;
    // redirect to oauth consent
    if (Object.keys(searchParams).length) {
      let stateParam = btoa(window.location.search);
      oauthURI += '&state=' + stateParam;
    }

    window.location.href = oauthURI;
  };


  $('#form_auth').submit(onFormSubmit);
  $('.connect-btns button[data-app]').click(onConnectAppClick);
  $('#login-email').click(showEmailSignin);
  $('#login-other-options').click(showSigninOptions);
  initPasswordToggles();

  // check if already logged-in
  checkSession();
  checkAutoFill();
  prependSearchParams();

  if (shouldShowEmailForm()) {
    showEmailSignin();
  }

  initAuthShowcaseCarousel();

  if (isSignupPage && window.gtag) {
    // console.log('is signup page', 'window.gtag', window.gtag, 'searchParams', searchParams)
    console.log('gtag-conversion', searchParams.campaign_id)
    var campaign_id = searchParams.campaign_id;
    if (campaign_id === 'adwords') {
      window.gtag('event', 'conversion', { 'send_to': 'AW-10780691895/TbyaCPGf88kDELeb0ZQo' });
    }
  }
});
